/** Truthy franchise flag as in StationsList (true / 1 / '1'). */
export function toFranchiseBool(value) {
  return value === true || value === 1 || value === '1'
}

/** Brand with optional « (Франшиза) » for FuelPlanner lists / popup / hover. */
export function formatStationBrand(station) {
  const brand = String(station?.brand ?? '').trim()
  if (!toFranchiseBool(station?.is_franchise)) return brand
  return brand ? `${brand} (Франшиза)` : 'Франшиза'
}
